
import React from 'react';
import { BookOpen } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent } from '@/components/ui/tabs';
import { FeatureGuide } from '@/types/knowledgeBase';
import CategoryTabs from './CategoryTabs';
import FeatureGuideList from './FeatureGuideList';
import QuickLinks from './QuickLinks';

interface FeatureGuidesSidebarProps {
  filteredGuides: FeatureGuide[];
  selectedGuide: FeatureGuide | null;
  setSelectedGuide: (guide: FeatureGuide) => void;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  activeTab: string;
  setActiveTab: (tab: string) => void;
  categories: string[];
}

const FeatureGuidesSidebar: React.FC<FeatureGuidesSidebarProps> = ({
  filteredGuides,
  selectedGuide,
  setSelectedGuide,
  searchTerm,
  setSearchTerm,
  activeTab,
  setActiveTab,
  categories
}) => {
  return (
    <>
      <Card className="mb-6">
        <CardHeader className="pb-3">
          <CardTitle className="text-xl flex items-center">
            <BookOpen className="mr-2 h-5 w-5 text-purple-600" />
            Feature Guides
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          <Tabs 
            value={activeTab} 
            onValueChange={setActiveTab}
            className="w-full"
          >
            <CategoryTabs 
              categories={categories} 
              activeTab={activeTab} 
              setActiveTab={setActiveTab} 
            />
            
            <TabsContent value={activeTab} className="mt-0">
              <FeatureGuideList 
                guides={filteredGuides}
                selectedGuide={selectedGuide}
                onSelectGuide={setSelectedGuide}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
              />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
      
      <QuickLinks />
    </>
  );
};

export default FeatureGuidesSidebar;
